import { render, staticRenderFns } from "./BtnGoLogin.vue?vue&type=template&id=e96c2c06&scoped=true&"
import script from "./BtnGoLogin.vue?vue&type=script&lang=js&"
export * from "./BtnGoLogin.vue?vue&type=script&lang=js&"
import style0 from "./BtnGoLogin.vue?vue&type=style&index=0&id=e96c2c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c2c06",
  null
  
)

export default component.exports